import { useState } from 'react';
import { Alert, Button, Box } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { apiError } from '../i18n/errors';
import api from '../api/client';
import { colors } from '../colors';

export default function EmailVerificationBanner() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [dismissed, setDismissed] = useState(false);

  if (!user || user.email_verified || dismissed) {
    return null;
  }

  const handleResend = async () => {
    setLoading(true);
    setMessage('');
    try {
      await api.post('/auth/resend-verification/', { email: user.email });
      setMessage('✅ Email de vérification envoyé ! Vérifiez votre boîte de réception.');
    } catch (err) {
      setMessage(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Alert 
        severity="warning"
        onClose={() => setDismissed(true)}
        sx={{
          bgcolor: colors.warningBgSolid,
          color: colors.warning,
          border: `1px solid ${colors.warning}`,
          borderRadius: 0,
          '& .MuiAlert-icon': { color: colors.warning },
        }}
        action={
          <Button
            size="small"
            onClick={handleResend}
            disabled={loading}
            sx={{
              color: colors.warning,
              fontWeight: 600,
              '&:hover': { bgcolor: 'rgba(245,158,11,0.1)' },
            }}
          >
            {loading ? 'Envoi...' : 'Renvoyer'}
          </Button>
        }
      >
        {message || `Votre email n'est pas vérifié. Vérifiez votre boîte de réception (${user.email}) ou cliquez sur "Renvoyer".`}
      </Alert>
    </Box>
  );
}
